module.exports = __webpack_public_path__ + "static/media/1.Pipes Range.4f34ffbc.png";